import { extractResultKeywords } from '../../utils/resultKeywords';

export default function ResultKeywordTags({ res, max = 3, className = '' }) {
  const keywords = extractResultKeywords(res, max);
  if (!keywords.length) return null;

  return (
    <ul className={`flex flex-wrap gap-1.5 ${className}`.trim()} aria-label="Extracted keywords">
      {keywords.map((kw) => (
        <li key={kw} className="feed-keyword-tag">
          {kw}
        </li>
      ))}
    </ul>
  );
}
